import advancedSettingsReducer from "./advancedSettings.reducer";

const initialState = {
  advancedSettings: advancedSettingsReducer(undefined, {}),
  xlsData: [],
  token: null,
  refreshToken: null,
  userName: "",
  userEmail: "",
  plantName: null,
  plantLocation: null,
  accessUserPlant: false,
  water_type: null,
  ro_nf_elements_used: null,
  dataset_name: null,
  sel_train: null,
  sel_pass: null,
  sel_stage: null,
  sel_pressure_vessels: null,
  sel_element_involved: null,
  tol_num_elements: null,
  num_trains: null,
  sel_element_type: null,
  ro_nf_stages: null,
  installation_date: "",
  warranty: false,
  noOfTrains: 1,
  cip_sequence: "CS003",
  alkali_chem_id: 6,
  alkali_price: null,
  alkali_used_per_cip: 0.9,
  alkali_cip_ph: 12,
  alkali_cip_temp: 25,
  alkali_cip_duration: 10,
  additive_alkali_chem_id: 10,
  additive_alkali_price: null,
  additive_alkali_used_per_cip: 0.225,
  additive_alkali_ph: 7,
  additive_alkali_temp: 25,
  additive_alkali_duration: 10,
  acid_chem_id: 1,
  acid_price: null,
  acid_used_per_cip: 0.5,
  acid_cip_ph: 1,
  acid_cip_temp: 25,
  acid_cip_duration: 10,
  additive_acid_chem_id: 10,
  additive_acid_price: null,
  additive_acid_used_per_cip: 0.5,
  additive_acid_ph: 7,
  additive_acid_temp: 25,
  additive_acid_duration: 10,
  file_id: null,
  plant_file_id: null,
  fileName: null,
  sheetName: null,
  fileSheetMapping: null,
  cips: null,
  cleanData: null,
  cleanDataUnits: null,
  flow: "m³/h",
  pressure: "bar",
  feed_quality: "uS/cm",
  feed_water_factor: "0.7",
  temperature: "C",
  permeate_quality: "uS/cm",
  feed_water_permeate_factor: "0.5",
  volume: "m³",
  currency: "USD",
  mass: "kg",
  conversion_rate: "1",
  cleaningEffectiness: null,
  fouling: null,
  predictionData: null,
  selectedValues: [],
  forecastWindow: null, // cleaning forecast window in days
  foulingType: null,
  appLanguage: "en",
  max_feed_pressure: 8,
  max_permeate_quality: 500,
  std_warranty_period: 3,
  startup_pressure_drop: null,
  designed_permeate_flow: null,
  std_membrane_age: 7,
  max_pressure_drop: 3.5,
  min_permeate_flow: null,
  nwp_trigger: null,
  forecast_window: null, // replacement forecast window in years
  analysisData: null,
  taskId: null,
  CATaskId: null, // remove this if not needed
  clusterPoints: 20,
  maxRelativeDistance: 3,
  medianCurvePoints: 20,
  permeateFlowDropThreshold: 15,
  pressureDropThreshold: 10,
  pressureDropThresholdAbsolute: 15,
  pressureDropThresholdType: "percentage",
  useSaltPassageChange: false,
  saltPassageIncreaseThreshold: 10,
  minDaysBetweenCIPs: 20,
  maxDaysBetweenCIPs: 180,
  cipIdentificationResolution: 5,
  minIdleDaysShutdown: 20,
  minStabilizationDaysAfterCIP: 0.042,
  maxStabilizationDaysAfterCIP: 14,
  minPointsForCleaningEffectiveness: 20,
  foulingAggressivenessFactor: 5,
  adaptPermeateFlowDropThreshold: true,
  adaptPressureDropThreshold: true,
  adaptSaltPassageThreshold: true,
  numberOfIterationsToFindOptima: 10,
  simulationImproveAccuracy: false,
  deafultStabilizationDaysAfterCIP: 10,
  failureProbabilityThreshold: 95,
  usePermeabilityTrigger: false,
  permeabilityOnly: false,
  permeabilityThreshold: 15,
  cleaningEffectinessThreshold: null,
  is_dupont_element: "Yes",
  add_info: "",
  digital: "",
  plantData: [],
  plantRowData: [],
  selTrain: 1,
  companyName: "", // Added companyName to initial state
  country: "",
  suggestedSettings: {},
  userChemicalLibrary: [],
  plantChemicalLibrary: [],
  plantUtilityCosts: {},
  trainUtilityCosts: {},
  trainChemicalSelection: {},
  licensePermissions: [],
  userProfileData: null,
  userLicenses: [],
  globalApiErrorCode: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "STORE_ACCESS_USER_PLANT": {
      return {
        ...state,
        accessUserPlant: action.payload,
      };
    }
    case "STORE_XLS_DATA":
      return {
        ...state,
        xlsData: action.payload,
      };
    case "STORE_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    case "STORE_USERNAME":
      return {
        ...state,
        userName: action.payload,
      };
    case "STORE_USEREMAIL":
      return {
        ...state,
        userEmail: action.payload,
      };
    case "STORE_COMPANY_NAME":
      return {
        ...state,
        companyName: action.payload,
      };
    case "STORE_DIGITAL":
      return {
        ...state,
        digital: action.payload,
      };
    case "SEL_SELECTED_TRAIN":
      return {
        ...state,
        selTrain: action.payload,
      };
    case "STORE_PLANT_DATA":
      return {
        ...state,
        plantData: action.payload,
      };
    case "STORE_PLANT_ROW_DATA":
      return {
        ...state,
        plantRowData: action.payload,
      };
    case "STORE_FILE_ID":
      return {
        ...state,
        file_id: action.payload.file_id,
        plant_file_id: action.payload.plant_file_id,
        fileName: action.payload.fileName,
        sheetName: action.payload.sheetName,
      };
    case "STORE_FILE_SHEET_MAPPING":
      return {
        ...state,
        fileSheetMapping: action.payload,
      };
    case "STORE_PLANT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_REQUEST_STATUS":
      return {
        ...state,
        requestStatus: action.payload,
      };
    case "STORE_USERDETAILS":
      return {
        ...state,
        email: action.payload.email,
        country: action.payload.country,
        role: action.payload.role,
        industry: action.payload.industry,
      };
    case "STORE_USERROLE":
      return {
        ...state,
        userRole: action.payload,
      };
    case "STORE_USER_PROFILE_DATA":
      return {
        ...state,
        userProfileData: action.payload || null,
        userLicenses: action.payload?.licenses || [],
      };
    case "STORE_CIPS": {
      return {
        ...state,
        cips: [...action.payload],
      };
    }
    case "STORE_DEFAULT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_SETTINGS_DEFAULTS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_SUGGESTED_SETTINGS": {
      return {
        ...state,
        suggestedSettings: action.payload,
      };
    }
    case "STORE_REPLACEMENT_THRESHOLD": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_CLEAN_DATA": {
      return {
        ...state,
        cleanData: action.payload.cleanData,
        cleanDataUnits: action.payload.cleanDataUnits,
        cleanDate: action.payload.cleanDate,
      };
    }
    case "STORE_UNITS": {
      return {
        ...state,
        flow: action.payload.flow,
        pressure: action.payload.pressure,
        feed_quality: action.payload.feed_quality,
        permeate_quality: action.payload.permeate_quality,
        temperature: action.payload.temperature,
        volume: action.payload.volume,
        currency: action.payload.currency,
        mass: action.payload.mass,
        conversion_rate: action.payload.conversion_rate,
        feed_water_permeate_factor: action.payload.feed_water_permeate_factor,
        feed_water_factor: action.payload.feed_water_factor,
      };
    }
    case "STORE_CLEANING_EFFECTIVNESS": {
      return {
        ...state,
        cleaningEffectiness: action.payload,
      };
    }
    case "STORE_FOULING": {
      return {
        ...state,
        fouling: action.payload,
      };
    }
    case "STORE_FOULING_TYPE": {
      return {
        ...state,
        foulingType: action.payload,
      };
    }
    case "STORE_PREDICTION_DATA": {
      return {
        ...state,
        predictionData: action.payload,
      };
    }
    case "STORE_SELECTED_VALUES": {
      return {
        ...state,
        selectedValues: action.payload,
      };
    }
    case "STORE_FORECAST_WINDOW": {
      return {
        ...state,
        forecastWindow: action.payload,
      };
    }
    case "STORE_REPLACEMENT_FORECAST_WINDOW": {
      return {
        ...state,
        forecast_window: action.payload,
      };
    }
    case "STORE_NO_OF_TRAINS": {
      return {
        ...state,
        noOfTrains: action.payload,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...initialState,
        ...(action.payload && action.payload),
        userName: state.userName,
        token: state.token,
        userEmail: state.userEmail,
        userLicenses: state.userLicenses,
        requestStatus: state.requestStatus,
        country: state.country,
        companyName: state.companyName,
      };
    }
    case "STORE_APP_LANGUAGE": {
      return {
        ...state,
        appLanguage: action.payload,
      };
    }
    case "STORE_ANALYSIS_DATA": {
      return {
        ...state,
        analysisData: action.payload,
      };
    }
    case "STORE_TASK_ID": {
      return {
        ...state,
        taskId: action.payload,
      };
    }
    // remove this action if not needed
    case "STORE_CA_TASK_ID": {
      return {
        ...state,
        CATaskId: action.payload,
      };
    }
    case "STORE_CLEANING_EFFECTIVNESS_THRESHOLD": {
      return {
        ...state,
        cleaningEffectinessThreshold: action.payload,
      };
    }
    case "STORE_USER_CHEMICAL_LIBRARY": {
      return {
        ...state,
        userChemicalLibrary: action.payload,
      };
    }
    case "STORE_PLANT_CHEMICAL_LIBRARY": {
      return {
        ...state,
        plantChemicalLibrary: action.payload,
      };
    }
    case "STORE_PLANT_UTILITY_COSTS": {
      return {
        ...state,
        plantUtilityCosts: action.payload,
      };
    }
    case "STORE_TRAIN_UTILITY_COSTS": {
      return {
        ...state,
        trainUtilityCosts: action.payload,
      };
    }
    case "STORE_TRAIN_CHEMICAL_SELECTION": {
      return {
        ...state,
        trainChemicalSelection: action.payload,
      };
    }
    case "STORE_LICENSE_PERMISSIONS": {
      return {
        ...state,
        licensePermissions: action.payload,
      };
    }
    case "STORE_GLOBAL_API_ERROR_CODE": {
      return {
        ...state,
        globalApiErrorCode: action.payload,
      };
    }
    case "CLEAR_AUTH_SESSION": {
      return {
        ...state,
        token: null,
        userName: "",
        userEmail: "",
        userRole: "",
        userProfileData: null,
        userLicenses: [],
      };
    }
    default: {
      const advancedSettings = advancedSettingsReducer(
        state.advancedSettings,
        action,
      );
      if (advancedSettings !== state.advancedSettings) {
        return { ...state, advancedSettings };
      }
      return state;
    }
  }
};

export { initialState };
export default rootReducer;
